/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import Table from 'antd/lib/table';
import { useVT } from 'virtualizedtableforantd4';

const scrollConfig = {
  y: 700,
  x: true,
};

const SmartTable = ({
  debug = false,
  infinity = false,
  dataSource = [],
  scroll = scrollConfig,
  onFetch = () => null,
  lastId,
  ...props
}: any) => {

  const [ vt ] = useVT(
    () => ({
      onScroll: ({ isEnd }) => {
        if (isEnd) {
          onFetch();
        }
      },
      scroll: { y: scrollConfig.y },
      debug,
    }),
    [lastId, dataSource]
  );

  return (
    <Table dataSource={dataSource} scroll={scroll} components={vt} pagination={false} {...props} />
  );
};

export default SmartTable;